import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCgUDcsCSo-EgGoSvzYgH1KkzV9WyA4l3A",
  authDomain: "tac-car-club.firebaseapp.com",
  projectId: "tac-car-club",
  storageBucket: "tac-car-club.firebasestorage.app",
  messagingSenderId: "356696551584",
  appId: "1:356696551584:web:ca96e1570741069dee99c5"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const fbStorage = getStorage(app);
